export default __webpack_public_path__ + "static/media/596.22b97a67.png";